
// src/services/companySeoService.js
import api from "./api";

const getCompanySeo = async () => {
  const response = await api.get(`/company-seo`);
  return response.data;
};

const updateCompanySeo = async (seoData) => {
  const response = await api.post(`/company-seo`, seoData);
  return response.data;
};

const companySeoService = {
  getCompanySeo,
  updateCompanySeo,
};

export default companySeoService;